/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import _ from 'lodash';
import moment from 'moment';
import globalStore from '$$globalStore';
import projectsModel from '$$projectModel';
import rights from '../../rights';
import resourcesOverload from '../../resourcesOverload';
import { api } from '$$store/api';

function _mappingApiTaskFieldsAndWebTaskFields(_task) {
  if (_task.name) _task.text = _task.name;

  if (_task.description !== undefined) _task.note = _task.description;

  if (_task.startDate) _task.start_date = _task.startDate;

  if (_task.endDate) _task.end_date = _task.endDate;

  if (_task.projectId) _task.gantt_id = _task.projectId;

  if (_task.ownerId) _task.owner_id = _task.ownerId;

  if (_task.createdAt) _task.created_at = _task.createdAt;

  if (_task.resources?.length) {
    _task.resources = _task.resources.map(r => {
      if (r.resourceId) {
        return {
          resource_id: r.resourceId,
          task_id: _task.id,
          ...r,
        };
      }

      return r;
    });
  }

  /**
  * priority options stored in DB with ids from 5 to 9
  * such operation maps it with api notation (from 1 to 5)
  * jira priority options id is far above 9 and have to be passed without mapping
  */
  if (_task.priority) _task.priority = _task.priority > 9 ? _task.priority : 6 - _task.priority + 4;

  return _task;
}

export function prepareTaskToRefresh(taskToUpdate) {
  let _task = _mappingApiTaskFieldsAndWebTaskFields({ ...taskToUpdate });

  const fieldsToUpdate = [
    'id', 'gantt_id', 'start_date', 'end_date', 'text', 'note', 'type', 'progress', 'duration', 'estimation', 'parent', 'sortorder', 'created_at',
    'owner_id', 'last_update', 'color', 'deadline', 'resource_id', 'status', 'priority', 'resources', 'constraint_type', 'constraint_date', 'jira_key',
    'comments', 'attachments', 'actual_cost', 'total_price',
  ];
  const numberFields = ['id', 'gantt_id', 'progress', 'duration', 'estimation', 'parent', 'sortorder', 'color', 'status', 'owner_id', 'priority', 'actual_cost', 'total_price'];
  const dateFields = ['start_date', 'end_date', 'last_update', 'deadline', 'constraint_date'];

  _task = _.pick(_task, fieldsToUpdate);

  _.each(numberFields, key => {
    if (key === 'estimation' && _task[key] > 0) {
      _task[key] = Math.round((+_task[key] / 60) * 100) / 100;
    }

    if (_task[key]) {
      _task[key] = +_task[key];
    }
  });

  _.each(dateFields, key => {
    if (_task[key]) {
      _task[key] = moment(_task[key]).toDate();
    }
  });

  return _task;
}

export function resourceHelper(resources, projectId = 0, allResourcesToTasks = {}) {
  const tasksMap = globalStore.getters['tasksModel/tasksByIds'];
  const taskIds = resources.reduce((result, assigned) => {
    const taskFromModel = tasksMap[assigned.taskId];

    if (taskFromModel) {
      result.push(+assigned.taskId);
    }

    return result;
  }, []);

  let ganttId = projectId;

  if (!projectId) {
    ganttId = tasksMap[taskIds[0]].gantt_id; // this will not work for update assign collaboration for multi projects
  }

  const tasksForCommit = [];
  const resourcesToTasksForCommit = [];

  taskIds.forEach(taskId => {
    tasksForCommit.push({
      id: +taskId,
      gantt_id: +ganttId,
      resources: _.cloneDeep(allResourcesToTasks[taskId]) || [],
    });

    resourcesToTasksForCommit.push({
      taskId: +taskId,
      ganttId: +ganttId,
      resourcesToTask: _.cloneDeep(allResourcesToTasks[taskId]) || [],
    });
  });

  if (!rights.project.hasRight(ganttId, 'all_tasks') && globalStore.getters['massChange/isEnabled']) {
    const resourceId = globalStore.getters['resourcesModel/getResourceByUserId'](user.id)?.id;
    const taskIdsToUnselect = [];

    resources.forEach(item => {
      if (item.unassignedResourcesIds?.includes(resourceId)) {
        const children = globalStore.getters['tasksModel/getAllChildByTask'](+ganttId, +item.taskId);

        taskIdsToUnselect.push(+item.taskId);
        taskIdsToUnselect.push(...children.map(task => +task.id));
      }
    });

    if (taskIdsToUnselect.length) {
      globalStore.commit('massChange/removeSelectedItems', { items: taskIdsToUnselect, fromGantt: false }, { root: true });
    }
  }

  if (tasksForCommit.length) {
    globalStore.commit('tasksModel/updateTasks', { tasks: tasksForCommit, fromGantt: false }, { root: true });
  }

  if (resourcesToTasksForCommit.length) {
    globalStore.commit('tasksModel/updateResourcesToTasks', { resourcesToTasks: resourcesToTasksForCommit, fromGantt: false }, { root: true });
    resourcesOverload.refreshCache();
  }

  if (taskIds.length) {
    globalStore.dispatch('headerView/setUIConfig');
    globalStore.dispatch('copyPaste/setCopyPasteError', { taskIds, text: 'can_not_copy_changes' }, { root: true });
  }

  return taskIds;
}

export function createCommentsHelper(comments) {
  const allGanttIds = projectsModel.getAllProjects().map(o => o.id);

  comments.forEach(comment => {
    if (allGanttIds.includes(comment.projectId)) {
      const resource = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);
      const resourceOnProjects = globalStore.getters['resourcesModel/getResourcesByProjectId'](comment.projectId);

      // uncomment this when commentsModel.onWSAddComment will be removed
      // dispatch('incrementHasCommentsInTask', { projectId: comment.projectId, taskId: comment.taskId });
      globalStore.commit('comments/addComment', { ...comment, fromGantt: false }, { root: true });

      if (resourceOnProjects.find(item => item.id === resource.id)) {
        const commentAction = {
          commentId: comment.id,
          date: comment.createdAt,
          read: 0,
          userId: window.user.id,
        };

        globalStore.commit('comments/addCommentAction', { ...commentAction, fromGantt: false }, { root: true });
      }
    }
  });
}

export function createAttachmentsHelper(attachments) {
  const allGanttIds = projectsModel.getAllProjects().map(o => o.id);

  attachments.forEach(attachment => {
    if (allGanttIds.includes(attachment.projectId)) {
      const taskData = globalStore.getters['tasksModel/getTaskByGanttId'](attachment.projectId, attachment.taskId);

      if (!taskData) {
        console.warn('[attachments] No task data for file upload:', attachment.projectId, attachment.taskId);

        return;
      }

      globalStore.commit('attachments/addAttachment', { projectId: attachment.projectId, attachment, fromGantt: false }, { root: true });

      projectsModel.updateProjectFileStore(attachment.projectId, attachment.size, 'upload');

      // const unreadComments = globalStore.getters['comments/getCommentsByProjectAndTaskId'](projectId, attachment.taskId).filter(comment => !comment.read);
      // const hasUnreadComments = unreadComments.length ? 1 : 0;
      // gantt.callEvent('addTaskAttachmentNotification', [projectId, attachment.taskId, 0, taskData.hasAttachments, hasUnreadComments]);
      // app.trigger(ID_EVENT_COLLABORATION_UPDATEDMODELS);
      // app.trigger('settingsProject:updateFileStore', attachment.size, { gantt_id: projectId, task_id: attachment.taskId }, 'upload');
    }
  });
}

export async function askJiraCustomColumnsAfterCreate(tasks) {
  for (const task of tasks) {
    await api.get(`/jira/custom_columns/${task.id}`, {
      baseURL: '',
    });
  }
}
